import { Component } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-college-rank',
  standalone: true,
  imports: [ButtonModule, DialogModule, AccordionModule],
  templateUrl: './college-rank.component.html',
  styleUrl: './college-rank.component.scss'
})
export class CollegeRankComponent {
  visible: boolean = false;

  showDialog() {
      this.visible = true;
  }
}
